const brand = process.env.NEXT_PUBLIC_BRAND ?? 'terschelling';
// eslint-disable-next-line import/no-dynamic-require
const popularPages: string[] = require(`./popularPages.${brand}`).default;
export default popularPages;
